import type { TFunction } from 'i18next';

import { EGoalType, type Goal } from '@feathr/blackbox';
import { currencyFormatter } from '@feathr/extender/utils';
import type { ListResponse } from '@feathr/rachis';

/** Returns true when the goals collection has loaded and contains at least one goal. */
export function hasAnyGoals(goals: ListResponse<Goal>): boolean {
  return goals.isLoaded && goals.models.length > 0;
}

/** Donation goals display "Variable" rather than a fixed currency amount. */
export function formatGoalValue(goal: Goal, t: TFunction): string {
  if (goal.get('conv_type') === EGoalType.donation_form_submission) {
    return t('Variable');
  }
  return currencyFormatter.format(goal.get('conv_value'));
}

/** Returns a comparable sort value; Infinity for donation conv_value keeps "Variable" separate from $0 goals. */
export function getGoalSortValue(goal: Goal, id: string): string | number {
  if (id === 'conv_value') {
    return goal.get('conv_type') === EGoalType.donation_form_submission
      ? Infinity
      : goal.get('conv_value') ?? 0;
  }
  return goal.get(id) ?? '';
}
